module.exports = __webpack_public_path__ + "static/media/logo.ab684112.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/logo.png
// module id = 111
// module chunks = 0